import React, { ReactElement } from 'react';
import { EmailStyle, LabelStyle } from './ChangeEmailStyle';
import TextLink from '../../../components/common/TextLink';
import { editEmailStyle } from '../../../components/common/CommonStyle';

interface EmailCaptionProps {
  label: string;
  email: string;
  showEdit?: boolean;
  handleEditClick?: () => void;
  customEmailStyle?: React.CSSProperties;
}
const EmailCaption = ({
  label,
  email,
  showEdit = false,
  handleEditClick,
  customEmailStyle,
}: EmailCaptionProps): ReactElement => {
  return (
    <>
      <LabelStyle>{label}</LabelStyle>
      <EmailStyle style={customEmailStyle}>
        {email}{' '}
        {showEdit && (
          // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
          <TextLink style={editEmailStyle} onClick={handleEditClick}>
            Edit
          </TextLink>
        )}
      </EmailStyle>
    </>
  );
};

export default EmailCaption;
